module.exports = {
    "cmhc": {
        "title": "Clinical Mental Health Counseling, MA",
        "thumbnail": "/assets/images/counseling-thumbnail.jpg",
        "document": "/assets/docs/Agnes-Scott-Clinical-Mental-Health-Counseling-MA.pdf",
        "teaser": "Get more details about **admissions requirements**, **program highlights**, and your **next steps**.",
        "form": "cmhc"
    },
}